<template>
    <div class="box">
        <div class="boxTop">
            <headerPage/>
            <div class="boxCenter">
                <div class="disFlex">
                    <div class="boxCenterLeft"></div>
                    <div class="boxCenterRight">
                        <div class="rightLogin">
                            <div class="loginTab">
                                <!--                <a href="" target=_parent></a>-->
                                <div :class="{act:isAct === 1}" class="zhTab" @click="loginTab(1)">账号登录</div>
                                <span>|</span>
                                <div :class="{act:isAct === 2}" class="kjTab" @click="loginTab(2)">快捷登录</div>
                            </div>
                            <div class="loginInput">
                                <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="demo-ruleForm logi-bgc">
                                    <div v-if="loginStatus" class="accountLogin">
                                        <div class="inputBox">
                                            <el-form-item prop="account">
                                                <el-input
                                                    v-model="ruleForm.account"
                                                    placeholder="请输入账号"
                                                    style="background: #0a2240;"
                                                    type="text"
                                                >
                                                    <i slot="prefix" class="iconfont icon-yan-shouji iconColor"></i>
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                        <div class="inputBox">
                                            <el-form-item prop="password">
                                                <el-input
                                                    v-model="ruleForm.password"
                                                    placeholder="请输入密码"
                                                    style="background: #0a2240;"
                                                    type="password"
                                                    @keyup.enter.native="login('ruleForm')"
                                                >
                                                    <i slot="prefix" class="iconfont icon-yan-mima iconColor"></i>
                                                </el-input>
                                            </el-form-item>
                                            <div class="notPass" @click="to('/findpass')">忘记密码?</div>
                                        </div>
                                        <div class="inputBox">
                                            <el-form-item class="self-center" label-width="0" ref="protocol" prop="protocol">
                                                <div class="flex align-center">
                                                    <el-checkbox-group v-model="ruleForm.protocol">
                                                        <el-checkbox label="agree">{{ '' }}</el-checkbox>
                                                    </el-checkbox-group>
                                                    <div class="protocol">我已阅读并同意<span class="text-org cursor"
                                                                                              @click="showProtocol = true">《用户协议》</span></div>
                                                </div>
                                            </el-form-item>
                                        </div>
                                    </div>
                                    <div v-else class="phoneLogin">
                                        <div class="inputBox">
                                            <el-form-item prop="tel">
                                                <el-input
                                                    v-model.number="ruleForm.tel"
                                                    placeholder="请输入手机号"
                                                    style="background: #0a2240;"
                                                >
                                                    <i slot="prefix" class="iconfont icon-yan-shouji iconColor"></i>
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                        <div class="inputBox">
                                            <el-form-item prop="code">
                                                <el-input
                                                    v-model.number="ruleForm.code"
                                                    placeholder="请输入验证码"
                                                    style="background: #0a2240;"
                                                    @keyup.enter.native="login('ruleForm')"
                                                >
                                                    <i slot="prefix" class="iconfont icon-i12 iconColor"></i>
                                                </el-input>
                                            </el-form-item>
                                            <div v-show="show" class="getCode" @click="checkPhone">获取验证码</div>
                                            <div v-show="!show" class="getCodeE">{{ count }}s</div>
                                        </div>
                                        <div class="inputBox">
                                            <el-form-item class="self-center" label-width="0" ref="protocol" prop="protocol">
                                                <div class="flex align-center">
                                                    <el-checkbox-group v-model="ruleForm.protocol">
                                                        <el-checkbox label="agree">{{ '' }}</el-checkbox>
                                                    </el-checkbox-group>
                                                    <div class="protocol">我已阅读并同意<span class="text-org cursor"
                                                                                              @click="showProtocol = true">《用户协议》</span></div>
                                                </div>
                                            </el-form-item>
                                        </div>
                                    </div>
                                    <el-form-item>
                                        <el-button class="loginBtn" @click="login('ruleForm')">立即登录</el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <!--              <div class="wxLogin"-->
                            <!--              >-->
                            <!--                <div class="wxLoginTit">使用其他方式登录</div>-->
                            <!--                <div class="wxLoginBtn">-->
                            <!--                  <a style="display: inline-block;-->
                            <!--                             width: 45px;-->
                            <!--                             height: 45px;-->
                            <!--                             background: #fff;-->
                            <!--                             border-radius: 100%;-->
                            <!--                             text-align: center;-->
                            <!--                             line-height: 45px;"-->
                            <!--                      :href="'https://open.weixin.qq.com/connect/qrconnect?appid=wxb42c7bf35b56e38f&redirect_uri=http://ysb.emof.cn/login&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect'">-->
                            <!--                    <img src="../../assets/images/wxxxx.png" alt="">-->
                            <!--                  </a>-->
                            <!--                  <p style="width: 100%;text-align: center;margin-top: 10px;color: #fff;">微信登录</p>-->
                            <!--                </div>-->
                            <!--              </div>-->
                            <!--<div class="notZh">-->
                            <!--我还没有账号，<span @click="to('/register')">我要注册</span>-->
                            <!--</div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <slot-content-dialog width="80%" :dialog="showProtocol" title="用户协议" @watchState="watchState">
            <div slot="content" class="detail protocol-content" v-html="agreement"></div>
        </slot-content-dialog>
        <footerPage/>
    </div>
</template>

<script>
import {passLogin, codeLogin, wxLogin, sendCode, getAgreement} from "@/api/login";
import headerPage from './common/headerPage'
import footerPage from './common/footerPage'
import SlotContentDialog from "@/components/SlotContentDialog.vue";

export default {
    name: "login",
    data() {
        return {
            code: '',
            isAct: 1,
            loginStatus: true,// 登录方式切换
            show: true, // 60秒倒计时
            count: '',
            timer: null,
            qianM: '', // 验证码
            ruleForm: {
                account: '',
                password: '',
                checked: false,
                tel: '',
                code: '',
                protocol: [],
            },
            rules: {
                account: [
                    {required: true, message: '请输入账号', trigger: 'blur'},
                    {min: 6, max: 20, message: '账号为手机号或分配账号', trigger: 'blur'}
                ],
                password: [
                    {required: true, message: '请输入密码', trigger: 'blur'},
                    {min: 6, max: 20, message: '密码格式不对', trigger: 'blur'}
                ],
                tel: [
                    {required: true, message: '请输入手机号'},
                    {validator: this.validateTel,}
                ],
                code: [
                    {required: true, message: '请输入验证码'},
                    {type: 'number', min: 6, message: '验证码为6位数字',}
                ],
                protocol: [
                    {required: true, message: '请先阅读并同意用户协议', trigger: 'change'}
                ],
            },
            agreement: '',
            showProtocol: false
        }
    },
    components: {
        SlotContentDialog,
        headerPage,
        footerPage
    },
    computed: {
        phone() {
            return this.$store.state.phone
        },
    },
    mounted() {
// 获取 messageBox DOM 后移除
        var el_message_box = document.querySelector('.el-message-box__wrapper')
        var v_modal = document.querySelector('.v-modal')
        if (el_message_box && v_modal) {
            el_message_box.parentNode.removeChild(el_message_box)
            v_modal.parentNode.removeChild(v_modal)
        }
    },
    created() {
        this.code = this.$route.query.code
        if (this.code) {
            this.weixinLogin()
        }
        this.getAgreement()
    },
    methods: {
        //手机号验证
        validateTel(rule, value, callback) {
            let reg = /^1[3456789]\d{9}$/;
            if (value === '') {
                callback(new Error('请输入手机号'));
            } else if (!reg.test(value)) {
                callback(new Error('请输入正确的手机号'));
            } else {
                callback();
            }
        },

        login(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.loginStatus) {
                        // 账号密码登录
                        this.passLogin()
                    } else {
                        // 验证码登录
                        this.codeLogin()
                    }
                } else {
                    this.$message.error('请检查是否填写完整');
                    return false;
                }
            });
        },

        // 密码登录
        async passLogin() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let _res = await passLogin(
                this.ruleForm.account,
                this.ruleForm.password
            )
            if (_res.status === 200) {
                loading.close();
                this.$store.state.user = _res.data
                this.$store.state.emofUserTokenSafer = _res.data.emofUserTokenSafer
                this.$store.state.cookie_user = JSON.stringify(_res.data)
                await window.localStorage.setItem('user', JSON.stringify(_res.data))

                if (this.$route.query.rout) {
                    this.$router.push({
                        path: this.$route.query.rout
                    })
                } else {
                    this.$router.replace('/home')
                }

            } else {
                loading.close();
                this.$message.error(_res.msg)
            }
        },

        // 验证码登录
        async codeLogin() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let _res = await codeLogin(
                this.ruleForm.tel,
                this.ruleForm.code
            );
            if (_res.status === 200) {
                loading.close();
                this.$store.state.user = _res.data
                this.$store.state.cookie_user = JSON.stringify(_res.data)
                this.$store.state.emofUserTokenSafer = _res.data.emofUserTokenSafer
                await window.localStorage.setItem('user', JSON.stringify(_res.data))
                if (this.$route.query.rout) {
                    this.$router.push({
                        path: this.$route.query.rout
                    })
                } else {
                    this.$router.push({
                        path: '/home'
                    })
                }
            } else {
                loading.close();
                this.$message.error(_res.msg)
            }
        },

        // 微信登录
        async weixinLogin() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let _res = await wxLogin(
                this.code
            );
            if (_res.status === 200) {
                loading.close();
                this.$store.state.user = _res.data
                this.$store.state.emofUserTokenSafer = _res.data.emofUserTokenSafer
                await window.localStorage.setItem('user', JSON.stringify(_res.data))
                this.$store.state.cookie_user = JSON.stringify(_res.data)
                this.$router.push({
                    path: '/home'
                })
            } else {
                loading.close();
                this.$message.error(_res.msg)
            }
        },

        // 验证手机号是否存在
        async checkPhone() {
            let reg = /^1[3456789]\d{9}$/;
            if (this.ruleForm.tel === '') {
                this.$message.error('请输入手机号');
                return false
            } else if (!reg.test(this.ruleForm.tel)) {
                this.$message.error('请输入正确的手机号');
                return false
            }
            // let _res = await CheckPhone(
            //     this.ruleForm.tel
            // );
            // if (_res.data === "1") {
            //   this.$message.error('此手机号尚未注册！');
            // }
            // if (_res.data === "2") {
            // 获取验证码
            this.getCode()
            // }
        },

        // 获取验证码
        async getCode() {
            this.$message.success('验证码发送成功！');
            this.getCodeTime()
            let _res = await sendCode(
                this.ruleForm.tel
            );
            if (_res.status === 200) {
                this.qianM = _res.data
            } else {
                this.$message.error(_res.msg)
            }
        },

        // 验证码倒计时
        getCodeTime() {
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                    } else {
                        this.show = true;
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000)
            }
        },

        // 账号手机号登录切换
        loginTab(num) {
            this.isAct = num
            this.loginStatus = num === 1 ? true : false
            this.$refs.ruleForm.resetFields()
        },

        // 跳转
        to(path) {
            this.$router.push(path)
        },
        async getAgreement() {
            let _data = await getAgreement()
            this.agreement = _data.data
        },
        watchState() {
            this.showProtocol = false
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep{
    .protocol{
        color: #ffffff;
        line-height: 1;
        .cursor{
            color: #ffa628;
        }
    }
    .el-checkbox__input.is-checked .el-checkbox__inner{
        background-color: #ffa628;
        border-color: #ffa628;
    }
}
.iconColor {
    color: #fff;
    font-size: 18px;
}

.act {
    color: #fff !important;
    border-bottom: 2px solid #fff;
}

.box {
    width: 100%;
    height: 100%;
    /*overflow-y: scroll;*/

    .boxTop {
        width: 100%;
        height: 822px;
        background: url(../../assets/images/login-bg.png) no-repeat center center;

        .boxCenter {
            min-width: 1200px;
            margin-top: 100px;
            display: flex;
            justify-content: center;

            .disFlex {
                width: 1200px;
                display: flex;
                justify-content: space-between;

                .boxCenterLeft {
                    width: 365px;
                    height: 270px;
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;

                    .leftNav {
                        width: 150px;
                        margin-top: 90px;
                        /*cursor: pointer;*/

                        img {
                            width: 43px;
                            height: 48px;
                            margin-left: 54px;
                        }

                        .tex {
                            width: 100%;
                            font-size: 24px;
                            color: #ffffff;
                            text-align: center;
                            margin-top: 15px;
                        }
                    }
                }

                .boxCenterRight {
                    width: 410px;
                    height: 520px;
                    border-radius: 10px;
                    display: flex;
                    justify-content: center;
                    background-color: #0a2240;
                    position: relative;
                    padding: 45px;
                    z-index: 1;

                    &:before {
                        position: absolute;
                        width: 489px;
                        height: 450px;
                        margin: 0 auto;
                        background: rgba(10, 34, 64, .3);
                        border-radius: 10px;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        content: "";
                        z-index: -1;
                    }

                    &:after {
                        position: absolute;
                        width: 561px;
                        height: 357px;
                        background: rgba(10, 34, 64, .1);
                        border-radius: 10px;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        content: "";
                        z-index: -1;
                    }


                    .rightLogin {
                        width: 348px;

                        .loginTab {
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border-bottom: 1px solid rgba(255, 255, 255, .5);

                            .zhTab {
                                font-size: 18px;
                                line-height: 40px;
                                color: rgba(255, 255, 255, .5);
                                cursor: pointer;
                            }

                            span {
                                font-size: 16px;
                                color: #bcbbbb;
                                padding: 0 40px;
                            }

                            .kjTab {
                                font-size: 18px;
                                line-height: 40px;
                                color: rgba(255, 255, 255, .5);
                                cursor: pointer;
                            }
                        }

                        .loginInput {
                            width: 100%;
                            margin-top: 25px;

                            .accountLogin {
                                width: 100%;

                                .inputBox {
                                    width: 100%;
                                    position: relative;

                                    .notPass {
                                        position: absolute;
                                        right: 12px;
                                        font-size: 12px;
                                        top: 15px;
                                        color: #fff;
                                        cursor: pointer;
                                    }

                                    input {
                                        width: 348px;
                                        height: 52px;
                                        border-radius: 8px;
                                        border: solid 1px #e2e2e1;
                                    }
                                }
                            }

                            .phoneLogin {
                                width: 100%;

                                .inputBox {
                                    width: 100%;
                                    position: relative;

                                    .getCode {
                                        position: absolute;
                                        right: 12px;
                                        font-size: 12px;
                                        top: 15px;
                                        color: #fff;
                                        cursor: pointer;
                                    }

                                    .getCodeE {
                                        position: absolute;
                                        right: 12px;
                                        font-size: 12px;
                                        top: 12px;
                                        color: #999;
                                        cursor: pointer;
                                    }


                                    input {
                                        width: 348px;
                                        height: 52px;
                                        border-radius: 8px;
                                        border: solid 1px #e2e2e1;
                                    }
                                }
                            }

                            .loginBtn {
                                width: 100%;
                                height: 46px;
                                background-image: linear-gradient(
                                        168deg, #ffb400, #fc7802), linear-gradient(#ff9600, #ff9600);
                                background-blend-mode: normal, normal;
                                border-radius: 10px;
                                text-align: center;
                                font-size: 18px;
                                color: #fff;
                                border: 0;
                                cursor: pointer;
                                -webkit-user-select: none;
                                -moz-user-select: none;
                                -ms-user-select: none;
                                user-select: none;
                            }
                        }

                        .wxLogin {
                            margin-top: 20px;

                            .wxLoginTit {
                                line-height: 30px;
                                text-align: center;
                                color: #bcbbbb;
                                position: relative;

                                &:before {
                                    position: absolute;
                                    top: 15px;
                                    left: 0;
                                    content: '';
                                    width: 85px;
                                    height: 1px;
                                    background: #bcbbbb;
                                }

                                &:after {
                                    position: absolute;
                                    top: 15px;
                                    right: 0;
                                    content: '';
                                    width: 85px;
                                    height: 1px;
                                    background: #bcbbbb;
                                }
                            }

                            .wxLoginBtn {
                                width: 100%;
                                text-align: center;
                                margin-top: 30px;

                                img {
                                    width: 26px;
                                    cursor: pointer;
                                }
                            }
                        }

                        .notZh {
                            width: 100%;
                            text-align: right;
                            font-size: 12px;
                            color: #323333;
                            margin-top: 20px;

                            span {
                                color: #0089ff;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
